'use client';
import React from 'react';

import { SessionContext } from '@benzinga/session-context';
import { AuthenticationManager, AuthenticationManagerEvent } from '@benzinga/session';
import Hooks from '@benzinga/hooks';

/**
 * Hook to check whether user is logged in or not
 */
export const useIsUserLoggedIn = (): boolean => {
  const session = React.useContext(SessionContext);
  const authManager = session.getManager(AuthenticationManager);
  const [loggedIn, setLoggedIn] = React.useState(authManager.isLoggedIn());

  Hooks.useSubscriber(
    authManager,
    React.useCallback(
      (event: AuthenticationManagerEvent) => {
        switch (event.type) {
          case 'unauthorized':
            setLoggedIn(false);
            break;
          case 'authentication:session_update':
            setLoggedIn(authManager.isLoggedIn());
        }
      },
      [authManager],
    ),
  );

  return loggedIn;
};
